module.exports = __webpack_public_path__ + "img/fig11.baa634df.jpg";